<template>
    <slot name="header_close"/>

    <div class="wrapper_dialog">
        <h3 class="title">
            {{ $t("tiktok.settings.delete_tag") }}
            <div class="number-block">
                <img class="icon" :src="tiktokIcon"/>
                <span>{{ info?.username }}</span>
            </div>
        </h3>

        <div class="content">
            <i18n-t keypath="tags.delete_confirm" tag="p" class="confirm">
                <template #tag>
                    <span class="value">{{ tagName }}</span>
                </template>
            </i18n-t>

            <div class="action_container">
                <ButtonLoading
                    type="submit"
                    :loading="button.loading"
                    :disabled="button.disabled"
                    @click="actionTag"
                >
                    {{ $t("common.delete") }}
                </ButtonLoading>
            </div>
        </div>
    </div>
</template>



<script setup>
// core
import {ref, computed, getCurrentInstance} from "vue";
import {useStore} from "vuex";

// components
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";

const store = useStore();
const tiktokIcon = require("@/assets/icons/tiktok.svg").default;
const {proxy} = getCurrentInstance();

const button = ref({
    loading: false,
    disabled: false,
});

const info = computed(() => store.state.dialogParams?.info);
const tagItem = computed(() => info.value?.tags?.[0] || "");
const tagName = computed(() => tagItem.value?.name || tagItem.value);

const onToggleLoadingButton = () => {
    button.value.loading = !button.value.loading;
    button.value.disabled = button.value.loading;
};

const actionTag = async () => {
    onToggleLoadingButton();

    try {
        await store.dispatch("tiktok/removeTag", {
            id: info.value?.tags?.[0]?.id,
            userId: info.value?.user_id,
            moshaToast: proxy.$moshaToast,
        });

        if (!!store.getters.getNextDialog) {
            store.commit("setTagsToDialogParams", []);
            store.commit("setDialog", store.getters.getNextDialog);
            store.commit("setNextDialog", "");
        } else {
            store.commit("closeDialog");
        }

        await store.dispatch("tiktok/loadAccounts", {
            visibility: info.value?.visibility,
        });
    } catch (e) {
        onToggleLoadingButton();
    }
};
</script>

<style lang="scss" scoped>
@use "@/styles/dialog-form.scss";
</style>
